<template>
  <div>
    <div v-if="isSubcontractor">
      <div class="pl-2 d-flex align-center">
        <p class="mb-0 caption font-weight-bold">{{ subpayment.title }}</p>
      </div>
      <div class="d-flex justify-space-between align-center mt-2">
        <div class="pl-2 d-flex align-center">
          <p class="mb-0 ml-1 caption">{{ subpayment.amount }}%</p>
        </div>
        <div class="d-flex align-center">
          <p class="text-right mb-0 caption font-weight-bold mr-2">
            {{ calculatedValues.uf | toThousandFilter(2) }} UF
          </p>
          <p class="text-right mb-0 caption font-weight-bold">
            ${{ calculatedValues.clp | toThousandFilter }} CLP
          </p>
        </div>
      </div>
      <div class="my-2">
        <StartPaymentSelection
          :payment="subpayment"
          :clp_amount="calculatedValues.clp"
          :uf_amount="calculatedValues.uf"
        />
      </div>
    </div>

    <div v-else>
      <div class="d-flex align-center gap-1">
        <v-text-field
          :value="subpayment.title"
          class="custom-height-search custom-height-calendar custom-type-text"
          hide-details
          dense
          outlined
          placeholder="Nombre"
          maxlength="80"
          @input="val => updateSubpaymentTitle(val)"
        ></v-text-field>
        <v-tooltip v-if="!subcontractSigned && !subcontractSuspended" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              x-small
              color="error"
              class="ml-1 flex-shrink-0"
              v-bind="attrs"
              v-on="on"
              @click="removeSubpayment"
            >
              <v-icon small>mdi-delete-outline</v-icon>
            </v-btn>
          </template>
          <span>Eliminar cuota</span>
        </v-tooltip>
      </div>
      <div class="d-flex justify-space-between align-center mt-2">
        <div class="pl-2 d-flex align-center">
          <v-text-field
            ref="amountInput"
            :value="subpayment.amount"
            class="custom-height-search custom-height-calendar custom-type-number"
            style="width: 40px"
            type="number"
            hide-details
            dense
            outlined
            @input="val => updateSubpaymentValue(val)"
          ></v-text-field>
          <p class="mb-0 ml-1 caption">%</p>
        </div>
        <div class="text-right">
          <p class="mb-0 caption font-weight-bold">{{ calculatedValues.uf | toThousandFilter(2) }} UF</p>
          <p class="mb-0 caption font-weight-bold">${{ calculatedValues.clp | toThousandFilter }} CLP</p>
        </div>
      </div>
      <div v-if="subcontractSigned || subcontractSuspended" class="my-2">
        <StartPaymentSelection
          :payment="subpayment"
          :clp_amount="calculatedValues.clp"
          :uf_amount="calculatedValues.uf"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StartPaymentSelection from './StartPaymentSelection.vue'
import { contractStatuses } from '@/components/Helpers/Constants/contract.js'

export default {
  name: 'SubpaymentItemDisplay',
  components: {
    StartPaymentSelection
  },
  props: {
    subpayment: {
      type: Object,
      required: true
    },
    calculatedValues: {
      type: Object,
      required: true,
      validator: (obj) => 'uf' in obj && 'clp' in obj
    },
    isSubcontractor: {
      type: Boolean,
      default: false
    },
    itemType: {
      type: String,
      required: true,
      validator: (value) => ['cost_table', 'reception', 'stage', 'specialty'].includes(value)
    },
    itemId: {
      type: [String, Number],
      required: true
    },
    paymentIndex: {
      type: Number,
      required: true
    },
    costPaymentIndex: {
      type: Number,
      required: true
    },
		subcontract: {
			type: Object,
			default: null
		},
    subcontractId: {
      type: [String, Number],
      default: null
    },
		paymentPercent: {
			type: Number,
			default: 0
		}
  },
	computed: {
		subcontractSigned(){
			return this.subcontract?.subcontract?.contract?.last_status?.status == this.contractStatuses.FIRMADO_AMBAS_PARTES
		},
		subcontractSuspended(){
			return this.subcontract?.subcontract?.contract?.last_status?.status == this.contractStatuses.SUBCONTRATO_ANULADO
		}
	},
  data() {
    return {
			contractStatuses
		}
	},
  methods: {
		updateSubpaymentTitle(newTitle) {
			this.$emit('update-title', {
				title: newTitle,
				costPaymentIndex: this.costPaymentIndex,
				paymentIndex: this.paymentIndex,
				itemType: this.itemType,
				itemId: this.itemId,
				subcontractId: this.subcontractId
			})
		},
    updateSubpaymentValue(newValue) {
      this.$emit('update-amount', {
        amount: newValue,
				costPaymentIndex: this.costPaymentIndex,
        paymentIndex: this.paymentIndex,
        itemType: this.itemType,
        itemId: this.itemId,
        subcontractId: this.subcontractId
      })
      // this.$nextTick(() => {
      //   if (this.$refs.amountInput) {
      //     this.$refs.amountInput.internalValue = this.subpayment.amount
      //   }
      // })
		},
    removeSubpayment() {
      this.$emit('remove-subpayment', {
				costPaymentIndex: this.costPaymentIndex,
        paymentIndex: this.paymentIndex,
        itemType: this.itemType,
        itemId: this.itemId,
        subcontractId: this.subcontractId
      })
    }
  }
}
</script>

<style scoped>
.payments-warning-box {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  margin-top: 6px;
  background-color: rgba(255, 18, 11, 0.08);
  border: 1px solid #FF120B;
  border-radius: 4px;
  color: #FF120B;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
}
</style>
